import React from "react";
import PayButton from "./PayButton";

export default function PayButtonPanel({ disabled, onClick, children }) {
    return (
        <div className="mt-1">
            <PayButton disabled={disabled} onClick={onClick}>
                {children}
            </PayButton>
        </div>
    );
}
